/**
 * Escape special characters in the search query to use it as a regular expression, this was
 * causing issues when the search query contained chars like `.` or `?` for example ".com"
 */
export function escapeRegExp(s: string) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}
